import { Control, Controller } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import GoogleLagTimesAlert from './google-lag-times-alert';
import { ReportFormValues } from '../reports-form-page';
import { SectionHeader } from '../../../../shared/section-header';
import Stack from '@mui/material/Stack';

interface StepDateSelectionProps {
  control: Control<ReportFormValues>;
}

export default function StepDateSelection({ control }: StepDateSelectionProps) {
  return (
    <Stack gap={2} width={'100%'} alignItems={'left'}>
      <SectionHeader description="Please provide a date going back from today to report on.">
        Date Selection
      </SectionHeader>
      <Controller
        name="startDate"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <DatePicker
              value={
                value === 0 || !value
                  ? dayjs().subtract(3, 'day')
                  : dayjs(value)
              }
              onChange={(newValue) => {
                if (newValue) {
                  onChange(newValue.valueOf());
                }
              }}
              label="Report Start Date"
              sx={{ maxWidth: 220 }}
            />
          );
        }}
      />
      <GoogleLagTimesAlert />
    </Stack>
  );
}
